// extracted by mini-css-extract-plugin
export var infoRow = "_uw-2";
export var labelContainer = "_uw-0";
export var rightInfo = "_uw-1";